import { ShieldCheck } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useVerificarIntegridadFondo } from '@/features/fondo-reserva/api';
import { IntegridadResult } from '@/features/fondo-reserva/integridad-result';
import { Button } from '@/components/ui/button';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function VerificarIntegridadRoute() {
  const { condoId } = useCondoContext();
  const verificar = useVerificarIntegridadFondo(condoId);

  return (
    <PageContainer width="wide">
      <PageHeader
        eyebrow="Finanzas · Fondo de reserva"
        title="Verificar integridad"
        subtitle="Verifica que la cadena de hashes del fondo de reserva no haya sido alterada. Cumplimiento Ley 21.442 Art. 7."
      />

      <div className="space-y-6">
        <div className="flex flex-col items-center gap-4 rounded-md border border-dashed border-[var(--color-hairline-strong)] bg-[var(--color-paper-dim)] px-6 py-12 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-paper)] text-[var(--color-ink-muted)] ring-1 ring-[var(--color-hairline-strong)]">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <div className="space-y-1">
            <p className="font-display text-lg font-semibold text-[var(--color-ink)]">
              Verificacion de integridad
            </p>
            <p className="max-w-md text-sm text-[var(--color-ink-muted)]">
              Este proceso recorre todos los movimientos del fondo y verifica que cada hash
              sea correcto y que la cadena no tenga eslabones rotos.
            </p>
          </div>
          <Button
            onClick={() => verificar.mutate()}
            disabled={verificar.isPending}
          >
            <ShieldCheck className="h-4 w-4" />
            {verificar.isPending ? 'Verificando...' : 'Ejecutar verificacion'}
          </Button>
        </div>

        {verificar.error && (
          <p className="text-sm text-[var(--color-danger)]">
            Error al ejecutar la verificacion. Intenta nuevamente.
          </p>
        )}

        {verificar.data && <IntegridadResult result={verificar.data} />}
      </div>
    </PageContainer>
  );
}
